<template>
  <div class="mb-5">
    <div class="text-uppercase text-secondary font-weight-bold py-3 px-4 border bg-light text-center">
      {{title}}
    </div>

    <div
        v-if="stages.length === 0"
        class="border-bottom border-right border-left bg-white p-4">
      Список пуст
    </div>

    <div
        v-for="stage in stages"
        :key="stage.id"
        class="">
      <div
          @click="$emit('select', stage.id)"
          class="py-3 px-4 border border-top-0 bg-light font-weight-bold text-secondary position-relative pointer">
        {{stage.title}} ({{formatDate(stage.dateFrom, 'y-m-d')}} - {{formatDate(stage.dateTo, 'y-m-d')}})
      </div>

      <div
          v-for="goal in stage.goals"
          :key="goal.id"
          class="border-bottom border-right border-left bg-white">
        <div class="p-3 position-relative on-hover-wrapper">
          <div class="d-inline-block mr-2 pointer">
            {{goal.status === 'canceled' ? '&#10006;' : (goal.status === 'achieved' ? '&#10004;' : '&#9711;')}}
          </div>

          {{goal.strategy.title}}
          <div class="position-absolute pointer on-hover-item" style="right: 10px; top:12px;">
            <span class="mr-2" @click="changeStatus(goal.id, stage.id, 'achieved')">&#10004;</span>
            <span @click="changeStatus(goal.id, stage.id, 'canceled')">&#10006;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientStrategyList',

  props: ['stages', 'title'],

  data() {
    return {};
  },

  methods: {
    changeStatus(id, stage, status) {
      this.$emit('change', {id, stage, status});
    },

    formatDate(dateString, format) {
      return formatDate(new Date(dateString), format);
    }
  },
};
</script>
